// extracted by mini-css-extract-plugin
module.exports = {"fullscreen":"componentloader_fullscreen__3HoF1","panel":"componentloader_panel__1oKEv"};